import React from "react";
import { LocaleProvider } from "@insightfulscience/smart-react/i18";
import { brandCodePropType } from "./propTypes";
import Component from "./Component";
import resources from "./locales";

const TopBar = ({ brandCode }) => (
	<LocaleProvider resources={resources}>
		<Component brandCode={brandCode} />
	</LocaleProvider>
);

TopBar.propTypes = {
	brandCode: brandCodePropType,
};

export default TopBar;
